export class AnonymousLanguageService {
    private _language: any;
    public get language(): any {
        return this._language;
    }
    public set language(value: any) {
        this._language = value;
    }
    constructor() {
        const w = window as any;
        if (w.b$
            && w.b$.portal
            && w.b$.portal.globalService
            && w.b$.portal.globalService.LanguageModel) {
            // Ok Langugae Model Exists
            this.language = w.b$.portal.globalService.LanguageModel.language;
        } else if (w.gadgets && w.gadgets.pubsub && w.gadgets.pubsub.subscribe) {
            // Old Angular1 global services will notify us when they are instantiated
            w.gadgets.pubsub.subscribe('OLB_ANGULAR1_GLOBAL_SERVICE_LOADED', (serviceName: string) => {
                if (serviceName === 'LanguageModel') {
                    this.language = w.b$.portal.globalService.LanguageModel.language;
                }
            });
        }
    }

    public onLanguageChange(callback: Function): void {
        (<any>window).b$.portal.globalService.LanguageModel.languageChangeCallbacks.push(callback);
        // callback(this.language.locale);
    }

    public detectLanguage(): void {
        (<any>window).b$.portal.globalService.LanguageModel.negotiateLanguage();
    }
}
